import CheckboxFormField from "components/checkbox-form-field";
import { Control } from "react-hook-form";
import { AppointmentFormValues } from "../appointment-form.component";
import PublicIcon from "@mui/icons-material/Public";
import FormControlLabel from "@mui/material/FormControlLabel";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";

type IsGlobalPracticeEventFieldProps = {
  control: Control<AppointmentFormValues, object>;
};

export default function IsGlobalPracticeEventField({
  control,
}: IsGlobalPracticeEventFieldProps) {
  return (
    <Box display="flex" justifyContent="flex-start" alignItems="flex-start">
      <PublicIcon sx={{ mt: 1.5, mr: 1.5 }} />

      <Stack
        direction="row"
        justifyContent="flex-start"
        sx={{ minWidth: "131px", mr: 0.35 }}
      >
        <FormControlLabel
          label="Show in all clinics"
          labelPlacement="start"
          sx={{ ml: 0 }}
          control={
            <CheckboxFormField
              testId="is_global_practice_event"
              name="is_global_practice_event"
              control={control}
            />
          }
        />
      </Stack>
    </Box>
  );
}
